// let va = document.getElementsByClassName("header-links")[0];
// va.classList.add('user-icon');

// document.addEventListener("DOMContentLoaded", function() {
// });

// document.getElementsByClassName('button wc-forward')[0].style.display = 'none';

document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
bubbles: true
}));